"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _classnames = _interopRequireDefault(require("classnames"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent Checkbox
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      marginRight: 4,
      marginLeft: 4,
      padding: 0,
      fontSize: 20
    },
    checked: {},
    checkedPrimary: {
      color: theme.palette.primary.main
    },
    checkedSecondary: {
      color: theme.palette.secondary.main
    },
    checkedPositive: {
      color: theme.palette.success.main
    },
    checkedNegative: {
      color: theme.palette.error.main
    },
    checkedMiddle: {
      color: theme.palette.warning.main
    },
    checkedNeutral: {
      color: theme.palette.neutral.main
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};
var HiCheckbox = /*#__PURE__*/function (_React$PureComponent) {
  function HiCheckbox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiCheckbox);
    _this = _callSuper(this, HiCheckbox, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  /**
   * Call callback function and stop click propagation
   * @param event
   * @param checked
   */
  (0, _inherits2.default)(HiCheckbox, _React$PureComponent);
  return (0, _createClass2.default)(HiCheckbox, [{
    key: "handleChange",
    value: function handleChange(event, checked) {
      // Stop propagation
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      if (this.props.onChange) {
        this.props.onChange(event, checked);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        color = _this$props.color,
        checkedIcon = _this$props.checkedIcon,
        icon = _this$props.icon,
        indeterminateIcon = _this$props.indeterminateIcon,
        style = _this$props.style,
        size = _this$props.size,
        className = _this$props.className,
        other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "color", "checkedIcon", "icon", "indeterminateIcon", "style", "size", "className"]);
      var iconStyles = (0, _objectSpread2.default)({
        width: size,
        height: size
      }, style);
      var hcolor = ['success', 'error', 'warning', 'neutral', 'inherit'].includes(color) ? 'default' : color;
      var checkboxIcon;
      if (icon) {
        var iconProps = {
          className: classes.root
        };
        if (typeof icon === 'string') {
          checkboxIcon = /*#__PURE__*/_react.default.createElement(_HiIcon.default, (0, _extends2.default)({
            icon: icon
          }, iconProps));
        } else if ((0, _typeof2.default)(icon) === 'object') {
          checkboxIcon = (0, _objectSpread2.default)({}, icon);
          checkboxIcon.props = (0, _objectSpread2.default)({}, checkboxIcon.props, {}, iconProps);
        }
      }
      return /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({
        classes: {
          root: classes.root,
          checked: (0, _classnames.default)(classes.checked, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.checkedPrimary, color === 'primary' || color === 'inherit'), classes.checkedSecondary, color === 'secondary'), classes.checkedPositive, color === 'success'), classes.checkedNegative, color === 'error'), classes.checkedMiddle, color === 'warning'), classes.checkedNeutral, color === 'neutral')),
          disabled: classes.disabled
        },
        style: iconStyles,
        color: hcolor,
        onChange: this.handleChange,
        icon: checkboxIcon
      }, checkedIcon && {
        checkedIcon: /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
          className: classes.root,
          icon: checkedIcon,
          color: color,
          size: 20
        })
      }, indeterminateIcon && {
        indeterminateIcon: /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
          className: classes.root,
          icon: indeterminateIcon,
          color: color,
          size: 20
        })
      }, other));
    }
  }]);
}(_react.default.PureComponent);
HiCheckbox.defaultProps = {
  checked: false,
  color: 'inherit',
  size: 20,
  icon: 'check_box_outline_blank'
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiCheckbox'
})(HiCheckbox);